import { isAuthenticated } from "@/routers/router-guardians"

const routes = [
  // {
  //   path: "/dashboard/calendar",
  //   name: "appointments_calendar",
  //   component: () => import("@/modules/scheduling/pages/appointment-calendar-old/AppointmentsCalendar.vue"),
  //   beforeEnter(to, from, next) {
  //     isAuthenticated(to, from, next)
  //   }
  // },
  {
    path: "/dashboard/calendar",
    name: "appointments_calendar",
    component: () => import("@/modules/scheduling/pages/appointment-calendar/AppointmentsCalendar.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
